import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import SnackBarComponent from "../Helpers/SnackBarComponent";
import axiosRequest from "../../api/axios";
import TableModalBUH from "./TableModalBUH";
import TableModalRBM from "./TableModalRBM";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { TableHeader, StyledTableRow } from "../Helpers/TableHeader";
import TableRow from "@mui/material/TableRow";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";

const headCells = [
  {
    id: "name",
    label: "BUHead Name",
    align: "left",
    padding: "0px",
  },
  {
    id: "quarter",
    label: "Quarter",
    align: "left",
    padding: "0px",
  },
  {
    id: "teamcode",
    label: "Teamcode",
    align: "left",
    padding: "0px",
  },
  {
    id: "rbmcode",
    label: "RBMCode",
    align: "left",
    padding: "0px",
  },
  {
    id: "view",
    label: "View ABM Data",
    align: "left",
    padding: "0px",
  },
  {
    id: "view",
    label: "View REPHQ Data",
    align: "left",
    padding: "0px",
  },
  {
    id: "Action",
    label: "Action",
    align: "left",
    width: "15px",
  },
];

const useStyles = makeStyles((theme) => ({
  container: {
    maxHeight: 1000,
  },
  fs12: {
    fontSize: "12px",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.secondary.main,
    // color: theme.palette.common.white,
    paddingLeft: 10,
    paddingRight: 5,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

export default function CommercialHeadBUH() {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const email = localStorage.getItem("email");
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const [showModal, setshowModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [showModal1, setshowModal1] = useState(false);
  const api_headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("Token"),
  };
  const handleClick = (row) => {
    setData(row.tabledata);
    setshowModal(true);
  };

  const handleClick1 = (row) => {
    setData1(row.tabledatarbm);
    setshowModal1(true);
  };
  const handleClose = () => {
    setOpensb(false);
  };
  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };

  const getData = async () => {
    setLoader(true);
    await axiosRequest({
      url: "bu_head_app/getbuhapprovaldata/",
      method: "POST",
      headers: api_headers,
      data: {
        reports_to: email,
        quarter:localStorage.getItem("quarter"),
        year:localStorage.getItem("year")
      },
    }).then((data) => {
      if (data.status === 200) {
        setRows(data?.data?.data);
        handleSnackBar("data loaded successfully", "success");
        setLoader(false);
      } else {
        handleSnackBar("no data found", "error");
        setLoader(false);
      }
    });
  };
  const [approved, setapproved] = React.useState(false);
  const [loaderApprove, setloaderApprove] = React.useState(false);
  const [loaderdisApprove, setloaderdisApprove] = React.useState(false);
  const handleApprove = async (row) => {
    setloaderApprove(true);
    await axiosRequest({
      url: "bu_head_app/buhapprove/",
      method: "POST",
      headers: api_headers,
      data: {
        teamcode: row.teamcode,
        rbmcode:row.rbmcode,
        id: row.id,
        email:row.name,
        // teamcode: localStorage.getItem("teamcode"),
        year: localStorage.getItem("year"),
        quarter: localStorage.getItem("quarter"),
      },
    }).then((data) => {
      if (data.status === 200) {
        setloaderApprove(false);
        setapproved(true);
        handleSnackBar("Approved the budgets", "success");
        getData();
      } else {
        setapproved(false);
        setloaderApprove(false);
        handleSnackBar("no data found", "error");
      }
    });
  };

  const handleDisApprove = async (row) => {
    setloaderdisApprove(true);
    await axiosRequest({
      url: "bu_head_app/buhdisapprove/",
      method: "POST",
      headers: api_headers,
      data: {
        teamcode: row.teamcode,
        rbmcode:row.rbmcode,
        email:localStorage.getItem("email"),
        year: localStorage.getItem("year"),
        quarter: localStorage.getItem("quarter"),
        id: row.id,
      },
    }).then((data) => {
      if (data.status === 200) {
        setloaderdisApprove(false);
        handleSnackBar("disapproved the budgets", "success");
      } else {
        setloaderdisApprove(false);
        handleSnackBar("no data found", "error");
      }
    });
  };

  React.useEffect(() => {
    getData();
  }, []);

  return (
    <React.Fragment>
      {loader === true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100vh",
          }}
        >
          <CircularProgress color="inherit" display={loader.toString()} />
        </div>
      ) : (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TableContainer
            className={classes.container}
            style={{ marginTop: 40, marginLeft: 40, marginBottom: 40 }}
          >
            <Table stickyHeader style={{ width: "915px", height: "auto" }}>
              <TableHeader headers={headCells} />
              <TableBody>
                {rows.map((row, index) => {
                  return (
                    <TableRow tabIndex={-1} key={index}>
                      <StyledTableCell className={classes.fs12} align="left">
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell className={classes.fs12} align="left">
                        {row.quarter}
                      </StyledTableCell>
                      <StyledTableCell className={classes.fs12} align="left">
                        {row.teamcode}
                      </StyledTableCell>
                      <StyledTableCell className={classes.fs12} align="left">
                        {row.rbmcode}
                      </StyledTableCell>
                      <StyledTableCell className={classes.fs12} align="left">
                        <button
                          className="save-btn"
                          onClick={() => handleClick1(row)}
                        >
                          view abm data
                        </button>
                      </StyledTableCell>
                      <StyledTableCell className={classes.fs12} align="left">
                        <button
                          className="save-btn"
                          onClick={() => handleClick(row)}
                        >
                          view rephq data
                        </button>
                      </StyledTableCell>
                      <StyledTableCell className={classes.fs12} align="left">
                        <button
                        disabled={row.status == "success"?true:false}
                          className="submit-btn"
                          onClick={() => handleApprove(row)}
                          style={{ backgroundColor: row.status == "success" ? "#e5e5e5" : "" ,color:"green",fontWeight:"bold"}}
                        >
                          {loaderApprove === true ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <CircularProgress
                                size="1rem"
                                color="inherit"
                                display={loaderApprove}
                              />
                            </div>
                          ) : (
                            <span> {row.status == "success" ? "Approved" : "Approve"}</span>
                          )}
                        </button>
                        <button
                          className="submit-btn"
                          style={{ marginLeft: 20 }}
                          onClick={() => handleDisApprove(row)}
                          disabled = {row.status == "success"?true:false}
                        >
                           {loaderdisApprove === true ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <CircularProgress
                                size="1rem"
                                color="inherit"
                                display={loaderdisApprove}
                              />
                            </div>
                          ) : (
                            <span> Dispprove</span>
                          )}
                        </button>
                      </StyledTableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
      <SnackBarComponent
        opensb={opensb}
        handleClose={handleClose}
        severity={severity}
        content={content}
      />
      <TableModalBUH open={showModal} data={data} setshowModal={setshowModal} />
      <TableModalRBM open={showModal1} data={data1} setshowModal={setshowModal1} />

    </React.Fragment>
  );
}
